var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import UsersSkeleton from '@/modules/admin/components/AccountManagementModal/AccountManagementUsersTab/UsersSkeleton.vue';
import UsersListItem from '@/modules/admin/components/AccountManagementModal/AccountManagementUsersTab/UsersListItem.vue';
import UsersEmpty from '@/modules/admin/components/AccountManagementModal/AccountManagementUsersTab/UsersEmpty.vue';
import { NotificationService } from '@/services/NotificationService';
import FiltersContainer from '@/modules/admin/containers/AccountManagementModal/AccountManagementTabs/AccountManagementUsersTab/Filters.container.vue';
import { getAccountInfo } from '@/clients/admin';
let AccountManagementUsersTabContainer = class AccountManagementUsersTabContainer extends Vue {
    constructor() {
        super(...arguments);
        this.columns = [
            { type: 'usuário', label: 'Usuário' },
            { type: 'status', label: 'Status' },
            { type: 'level', label: 'Nível' },
        ];
        this.initialAllowedUsers = 0;
        this.allowedUsers = 0;
        this.edittingAllowedUsersTotal = false;
        this.loadingUsers = true;
        this.loadingAccountInfo = true;
    }
    async mounted() {
        const accountId = this.$store.getters['admin/get_selected_account'];
        this.getAccountInfo(accountId);
        this.getSubUsers(accountId);
    }
    async getSubUsers(accountId) {
        await this.$store.dispatch('admin/fetch_sub_users', { accountId });
        this.loadingUsers = false;
    }
    async getAccountInfo(accountId) {
        try {
            const response = await getAccountInfo(accountId);
            this.allowedUsers = response.data.allowed_users;
            this.initialAllowedUsers = response.data.allowed_users;
        }
        catch (e) {
            console.log(e);
        }
        this.loadingAccountInfo = false;
    }
    destroyed() {
        this.$store.dispatch('admin/reset_sub_users');
    }
    async setAllowedUsersTotal() {
        this.edittingAllowedUsersTotal = false;
        const accountId = this.$store.getters['admin/get_selected_account'];
        const body = {
            account: {
                max_users_count: this.allowedUsers,
            },
        };
        try {
            await Vue.axios.post(`accounts/max_users_count/${accountId}`, body);
            NotificationService.success('Sucesso', 'Total de usuários alterado com sucesso');
        }
        catch (e) {
            NotificationService.error('Erro', 'Não foi possível alterar a quantidade de usuários. Por favor, tente novamente');
        }
    }
    resetAllowedUsersTotal() {
        this.allowedUsers = this.initialAllowedUsers;
        this.edittingAllowedUsersTotal = false;
    }
    async showUser(user) {
        this.$store.dispatch('admin/select_sub_user', { userId: user.id });
        this.$store.dispatch('admin/update_right_tab_of_modal', 'UsersDetail');
    }
    get subUsers() {
        return this.$store.getters['admin/get_sub_users'];
    }
};
AccountManagementUsersTabContainer = __decorate([
    Component({
        components: {
            Input,
            UsersListItem,
            UsersSkeleton,
            UsersEmpty,
            FiltersContainer,
        },
    })
], AccountManagementUsersTabContainer);
export default AccountManagementUsersTabContainer;
